import useFetchCandidateProfile from './useFetchCandidateProfile'

export default useFetchCandidateProfile
